import { render, staticRenderFns } from "./ReviewChanges.vue?vue&type=template&id=007de1d7&scoped=true"
import script from "./ReviewChanges.vue?vue&type=script&lang=js"
export * from "./ReviewChanges.vue?vue&type=script&lang=js"
import style0 from "./ReviewChanges.vue?vue&type=style&index=0&id=007de1d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007de1d7",
  null
  
)

export default component.exports